import { render, staticRenderFns } from "./DashboardFooter.vue?vue&type=template&id=46fdbd05&scoped=true"
import script from "./DashboardFooter.vue?vue&type=script&lang=js"
export * from "./DashboardFooter.vue?vue&type=script&lang=js"
import style0 from "./DashboardFooter.vue?vue&type=style&index=0&id=46fdbd05&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46fdbd05",
  null
  
)

export default component.exports